import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ManagePeopleTable } from './components/ManagePeopleTable';
import { ManagePeopleActions } from './components/ManagePeopleActions';
import { ManagePeopleEmptyState } from './components/ManagePeopleEmptyState';
import EnterpriseContext from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/providers/Enterprise/Enterprise.context';
import EnterpriseMembersProvider from 'providers/EnterpriseMembers';
import EnterpriseMembersContext from 'providers/EnterpriseMembers/EnterpriseMembers.context';

import './ManagePeople.styles.scss';
import './ManagePeople.styles.responsive.scss';

type ManagePeopleProps = {
  className?: string;
};

const ManagePeople: React.FC<ManagePeopleProps> = (props) => {
  const { className } = props;

  const { enterprise } = useContext(EnterpriseContext);
  const { isEmpty } = useContext(EnterpriseMembersContext);

  const { brandName } = enterprise || {};

  const classes = classNames('manage-people', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div>
        <h1>{t('manageEnterprisePeople', { brandName })}</h1>

        {!isEmpty && <ManagePeopleActions showLimit />}
      </div>

      {isEmpty ? <ManagePeopleEmptyState /> : <ManagePeopleTable />}
    </div>
  );
};

const ManagePeoplePage: React.FC = () => {
  const { enterprise, updateBusinessUnits } = useContext(EnterpriseContext);

  return (
    <EnterpriseMembersProvider
      enterprise={enterprise}
      updateBusinessUnits={updateBusinessUnits}
    >
      <ManagePeople />
    </EnterpriseMembersProvider>
  );
};

export default ManagePeoplePage;
